export default {
  manufacturerModelName: { field: 'manufacturerModelName' },
  unitTypeName: { field: 'unitTypeName' },
  isActive: { field: 'isActive', fieldType: 'boolean' },
  waterUnitOfMeasureCode: { field: 'waterUnitOfMeasureCode' },
  allReportEmails: { field: 'allReportEmails' },
  goodReportEmails: { field: 'goodReportEmails' },
  badReportEmails: { field: 'badReportEmails' }
};
